import { Button, Col, Row, Modal, notification } from "antd";
import React, { useState } from "react";
import { Flower } from "../../@type/flowerType";
import img2 from "../../..//accset/category/image2.png";
import { Link } from "react-router-dom";
import { dispatch } from "../../redux/store";
import { deleteFlower } from "../../redux/action/flower";

interface Props {
  flower: Flower[];
}

export default function ProductItem({ flower }: Props) {
  const [open, setOpen] = useState(false);
  const [selectedFlower, setSelectedFlower] = useState<Flower | null>(null);

  const handleOpenModal = (
    e: React.MouseEvent,
    item: Flower
  ) => {
    e.preventDefault(); // chặn Link
    e.stopPropagation();
    setSelectedFlower(item);
    setOpen(true);
  };

const handleDelete = async () => {
  if (!selectedFlower) return;

  try {
    await dispatch(deleteFlower(Number(selectedFlower.flowerId)));

    notification.success({
      message: "Xoá thành công",
      description: `Đã xoá ${selectedFlower.name}`,
      placement: "topRight",
    });

    setOpen(false);
    setSelectedFlower(null);
  } catch (error) {
    notification.error({
      message: "Xoá thất bại",
      description: "Vui lòng thử lại sau",
      placement: "topRight",
    });
  }
};


  return (
    <>
      <Row gutter={[24, 24]}>
        {flower.map((item) => (
          <Col key={item.flowerId} xl={6} lg={8} md={12} sm={24} xs={24}>
            <Link to={`/Product/${item.flowerId}`}>
              <div
                style={{
                  background: "#fff",
                  borderRadius: 12,
                  overflow: "hidden",
                  boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
                  cursor: "pointer",
                  transition: "all 0.3s",
                }}
                className="hover:shadow-md"
              >
                {/* Ảnh */}
                <div
                  style={{
                    position: "relative",
                    width: "100%",
                    paddingBottom: "100%",
                    backgroundColor: "#fdeef0",
                  }}
                >
                  <img
                    src={item.images?.[0]?.imageUrl || img2}
                    alt={item.name}
                    style={{
                      position: "absolute",
                      inset: 0,
                      width: "100%",
                      height: "100%",
                      objectFit: "cover",
                    }}
                  />
                </div>

                <div style={{ padding: "12px 16px" }}>
                  <p style={{ fontSize: 13, color: "#666", margin: 0 }}>
                    Vòng đời: {item.lifespan}
                  </p>

                  <h2
                    style={{
                      fontWeight: 700,
                      fontSize: 16,
                      color: "#111",
                      marginBlock: 12,
                    }}
                  >
                    {item.name}
                  </h2>

                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      fontSize: 13,
                    }}
                  >
                    <span>{item.origin}</span>

                    <Button
                      danger
                      size="small"
                      onClick={(e) => handleOpenModal(e, item)}
                    >
                      Xoá
                    </Button>
                  </div>
                </div>
              </div>
            </Link>
          </Col>
        ))}
      </Row>

      {/* Modal xác nhận */}
      <Modal
        open={open}
        title="Xác nhận xoá"
        onOk={handleDelete}
        onCancel={() => setOpen(false)}
        okText="Xoá"
        centered
        okButtonProps={{ danger: true }}
        cancelText="Huỷ"
      >
        <p>
          Bạn có chắc muốn xoá hoa{" "}
          <strong>{selectedFlower?.name}</strong> không?
        </p>
      </Modal>
    </>
  );
}
